import {ENTITY_TYPE, INPUT_ENTITY_MAP} from '../../api/constants';
import {BLOCK_TYPE, DraftUtils} from "draftail";
import {Stack} from "immutable";
import {SelectionState, EditorState, Modifier} from "draft-js";

export default function createHorizontalRulePlugin() {
    const store = {
        getEditorRef: undefined,
        getReadOnly: undefined,
        getEditorState: undefined,
        setEditorState: undefined,
    };
    return {
        initialize: ({ getEditorRef, getReadOnly, getEditorState, setEditorState }) => {
            store.getReadOnly = getReadOnly;
            store.getEditorRef = getEditorRef;
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },
        handleBeforeInput: (char,editorState,timestamp) => {
            let res = false;

            const selection = editorState.getSelection();

            const block = DraftUtils.getSelectedBlock(editorState);
            const startOffset = selection.getStartOffset();
            const text = block.getText();
            const beforeInput = text.slice(0, startOffset);
            const mark = "".concat(beforeInput).concat(char);

            if (mark === INPUT_ENTITY_MAP[ENTITY_TYPE.HORIZONTAL_RULE] && block.getType() !== BLOCK_TYPE.CODE) {
                let undoStack = editorState.getUndoStack();

                //first remove INPUT_ENTITY_MAP[ENTITY_TYPE.HORIZONTAL_RULE]
                const contentState = editorState.getCurrentContent();
                const updateSelection = SelectionState.createEmpty(selection.anchorKey).set('focusOffset', 2);
                const contentStatesAfterDelete = Modifier.removeRange(contentState, updateSelection, 'forward')
                const editorStateAfterDelete = EditorState.push(editorState, contentStatesAfterDelete, 'remove-range');

                // add horizontal line
                const newEditorState = DraftUtils.addHorizontalRuleRemovingSelection(editorStateAfterDelete);
                const currentContent = newEditorState.getCurrentContent();
                undoStack = undoStack.push(currentContent);

                const editorStateChanges = {
                    currentContent,
                    undoStack,
                    redoStack: Stack(),
                    lastChangeType: 'insert-characters',
                    selection: contentState.getSelectionAfter(),
                    forceSelection: false,
                    inlineStyleOverride: editorState.getInlineStyleOverride()
                };

                const newEditorState2 = EditorState.set(editorState, editorStateChanges);
                store.setEditorState(newEditorState2);

                res = 'handled'; //reserved key to notice draft js that horizontal rule is handled and no action needed
            }

            return res;
        }
    };
};